

export const quiz =  {

  "appLocale": {
  "landingHeaderText": "Digital Foundation (<questionLength> Questions)",
  "question": "Question",
  "startQuizBtn": "Continue",
  "resultFilterAll": "All",
  "resultFilterCorrect": "Correct",
  "resultFilterIncorrect": "Incorrect",
  "prevQuestionBtn": "Prev",
  "nextQuestionBtn": "Next",
  "resultPageHeaderText": "You have completed the assessment. You got <correctIndexLength> out of <questionLength> questions."
},

  "quizTitle": "Digital Foundation",
  "quizSynopsis": "This assessment is designed to evaluate a your understanding of core computer essentials, specifically focusing on basic hardware/software knowledge and fundamental file management skills.",
  "noOfQuestions": "30",
  "questions": [
    {
      "question": "What does CPU stand for?",
      "questionType": "text",
      // "questionPic": "https://codefussion.tech/elearning/assets/quiz-images/html.png", // if you need to display Picture in Question
      "answerSelectionType": "single",
      "answers": [
        "Central Processing Unit",
        "Computer Personal Unit",
        "Central Process Utility",
        "Controlled Program Unit"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Central Processing Unit",
      "point": "3"
    },
    {
      "question": "Which of these are examples of input devices?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Monitor",
        "Keyboard",
        "Mouse",
        "Speaker",

      ],
      "correctAnswer": [1, 2],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "What is the main purpose of RAM (Random Access Memory)?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "To store data permanently",
        "To process graphics",
        "To provide temporary storage for active programs and data",
        "To connect to the internet"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "To provide temporary storage for active programs and data",
      "point": "4"
    },
    {
      "question": "Which of these is NOT an operating system?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Microsoft Windows",
        "macOS",
        "Google Chrome",
        "Linux",
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Google Chrome",
      "point": "3"
    },
    {
      "question": "What does URL stand for?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Uniform Resource Locator",
        "Universal Reference Link",
        "Unified Retrieval Language",
        "Uniform Return Locator",
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "bUniform Resource Locator",
      "point": "3"
    },
    {
      "question": "What is the primary function of an operating system?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "To create spreadsheets",
        "To manage the computer's hardware and software resources",
        'To protect against viruses',
        "To browse the web",
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'To manage the computer\'s hardware and software resources',
      "point": "3"
    },
    {
      "question": "Which of these is the brain of the computer?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "RAM",
        "Hard Drive",
        "CPU",
        "Motherboard",
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'CPU',
      "point": "5"
    },

    // {
    //   "question": "which of the following is the correct way to insert an image",
    //   "questionType": "photo",
    //   "answerSelectionType": "single",
    //   "answers": [
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-1.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-2.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-3.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-4.png"
    //   ],
    //   "correctAnswer": "4",
    //   "messageForCorrectAnswer": "Correct answer. Good job.",
    //   "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
    //   "explanation": "The image tag uses the src attribute and is a self-closing tag",
    //   "point": "5"
    // },
    // {
    //   "question": "Which of the following statements about CSS is true?",
    //   "questionType": "text",
    //   "answerSelectionType": "multiple",
    //   "answers": [
    //     "CSS stands for cascading style sheet",
    //     "CSS is the styling and beautification of your website",
    //     "CSS is a program language",
    //     "CSS is a not a program language",

    //   ],
    //   "correctAnswer": [1, 2, 4],
    //   "messageForCorrectAnswer": "Correct answer. Good job.",
    //   "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
    //   "explanation": "Selected statements are true",
    //   "point": "5"
    // },
    {
      "question": "Which port is commonly used to connect a printer to a computer?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "HDMI",
        "USB",
        "Ethernet",
        "3.5mm Audio Jack",
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'USB',
      "point": "3"
    },
    {
      "question": "What type of software is a web browser like Firefox or Chrome? ",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Operating System',
        'Application Software',
        'Utility Software',
        'Firmware',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Application Software',
      "point": "3"
    },
    {
      "question": "What is the purpose of a network router?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'To provide power to the computer',
        'To display images on the monitor',
        'To direct traffic between different computer networks',
        'To store backup files',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'To direct traffic between different computer networks',
      "point": "3"
    },
    {
      "question": "Which of these are considered malicious software (malware)? Select all that apply. ",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        'Virus',
        'Spreadsheet',
        'Trojan Horse',
        'Word Processor',
      ],
      "correctAnswer": [1,3],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Selected answers are true',
      "point": "5"
    },
    {
      "question": "What does the 'https://' in a web address signify? ",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "The website has high-resolution pictures",
        "The connection to the website is secure and encrypted",
        "The website is a hypertext document",
        "The website is the home page"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "The connection to the website is secure and encrypted",
      "point": "3"
    },
    {
      "question": "A file extension (e.g., .txt, .jpg) primarily indicates what?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'The file\'s size',
        'The date the file was created',
        'The type of data in the file and which program can open it',
        'The file\'s author',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'The type of data in the file and which program can open it',
      "point": "3"
    },
    {
      "question": "What is the name of the bar typically found at the bottom of a Windows desktop that shows open programs and the Start button?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Menu Bar',
        'Status Bar',
        'Title Bar',
        'Taskbar',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Taskbar',
      "point": "3"
    },
    {
      "question": "Which keyboard shortcut is used to paste copied text or a file?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Ctrl + C',
        'Ctrl + V',
        'Ctrl + X',
        'Ctrl + P',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Ctrl + V',
      "point": "3"
    },
    {
      "question": "What is the term for a collection of files stored together?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Folder',
        'Application',
        'Drive',
        'Extension',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Folder',
      "point": "3"
    },
    {
      "question": "If you want to select several non-adjacent files in a folder, which key do you hold down?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Shift',
        'Alt',
        'Ctrl (Control)',
        'Tab',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Ctrl (Control)',
      "point": "3"
    },
    {
      "question": "The 'C:' drive in Windows typically refers to what?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'The CD/DVD drive',
        'The main hard drive where the operating system is installed',
        'The cloud storage drive',
        'The USB drive',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'The main hard drive where the operating system is installed',
      "point": "3"
    },
    {
      "question": "What is the action of moving a file from your computer to a server on the internet called?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Downloading',
        'Copying',
        'Uploading',
        'Saving',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Uploading',
      "point": "3"
    },
    {
      "question": "Which of the following file extensions indicate a compressed archive? Select all that apply. ",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        '.zip',
        '.exe',
        '.rar',
        '.docx',
      ],
      "correctAnswer": [1,3],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Selected options are true',
      "point": "4"
    },
    {
      "question": "Renaming a file typically changes:",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'The file\'s content and its name.',
        'Only the file\'s name, not its content.',
        'The file\'s location and its name.',
        'The program needed to open the file.',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Only the file\'s name, not its content.',
      "point": "3"
    },
    {
      "question": "What is the purpose of the 'Recycle Bin' (Windows) or 'Trash' (macOS)? ",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "To permanently delete files immediately",
        "To create a backup of important files automatically",
        "To hold files before they are permanently deleted",
        "To compress files to save space"
      ],
      "correctAnswer": '3',
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "To hold files before they are permanently deleted",
      "point": "3"
    },
    {
      "question": "Which of these are best practices for file management? Select all that apply.",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        'Create folders to organize files by project or type.',
        'Give files descriptive names.',
        'Save all files directly to the desktop.',
        'Regularly delete or archive old files you no longer need.',
      ],
      "correctAnswer": [1,2,4],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Selected optins are true',
      "point": "5"
    },
    {
      "question": "A file with the extension .mp3 is most likely what type of file? ",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'A video file',
        'A text document',
        'An audio file',
        'A spreadsheet file',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'An audio file',
      "point": "3"
    },
    {
      "question": "What does 'PDF' stand for?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Printable Document Format',
        'Portable Document Format',
        'Personal Data File',
        'Public Domain File',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Portable Document Format',
      "point": "3"
    },
    {
      "question": "What is a strong password likely to include? Select all that apply",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        'A combination of uppercase and lowercase letters',
        'Your name or username',
        'Numbers and symbols',
        'Is at least 12 characters long',
      ],
      "correctAnswer": [1,3,4],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Selected options are true',
      "point": "4"
    },
    {
      "question": "What does 'GUI' stand for? ",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'General User Interface',
        'Graphical Uniform Interaction',
        'Graphical User Interface',
        'Guided User Instruction',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'source',
      "point": "3"
    },
    {
      "question": "The process of restarting a computer is called:",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Shutting down',
        'Booting',
        'Rebooting',
        'Hibernating',

      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'Rebooting',
      "point": "3"
    },
    {
      "question": "What is two-factor authentication (2FA)?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'Using two different passwords',
        'A security process that requires two different methods to verify your identity',
        'Having two user accounts on one computer',
        'Logging in from two different devices',

      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'A security process that requires two different methods to verify your identity.',
      "point": "3"
    },
    {
      "question": "Why is it important to regularly install software updates?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'They always add exciting new features.',
        'They often include critical security patches to fix vulnerabilities.',
        'They make the computer run faster without exception.',
        'They increase the storage space on the hard drive.',

      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'They often include critical security patches to fix vulnerabilities.',
      "point": "3"
    },
  ]
}
